"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

require("@albelli/arc-3/lib/buttons.css");

require("@albelli/arc-3/lib/core.css");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = function Button(_ref) {
  var _classnames;

  var id = _ref.id,
      children = _ref.children,
      type = _ref.type,
      className = _ref.className,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      small = _ref.small,
      disabled = _ref.disabled,
      color = _ref.color,
      onClick = _ref.onClick,
      href = _ref.href,
      appStore = _ref.appStore,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["id", "children", "type", "className", "secondary", "tertiary", "small", "disabled", "color", "onClick", "href", "appStore", "title"]);

  var primary = !secondary && !tertiary && !appStore;
  var classes = (0, _classnames2.default)((_classnames = {
    "arc3-btn": primary,
    "arc3-btn-secondary": secondary,
    "arc3-btn-tertiary": tertiary,
    "arc3-btn--small": primary && small,
    "arc3-btn-secondary--small": secondary && small,
    "arc3-btn-tertiary--small": tertiary && small
  }, _defineProperty(_classnames, "arc3-btn--color-brand-".concat(color), (primary || secondary) && color), _defineProperty(_classnames, "arc3-btn-tertiary--color-brand-".concat(color), tertiary && color), _defineProperty(_classnames, "arc3-app-store-btn arc3-app-store-btn--".concat(appStore), appStore), _defineProperty(_classnames, "arc3-btn--disabled", primary && disabled), _defineProperty(_classnames, "arc3-btn-secondary--disabled", secondary && disabled), _defineProperty(_classnames, "arc3-btn-tertiary--disabled", tertiary && disabled), _classnames), className);

  var getTarget = function getTarget(target) {
    if (target.tagName.toUpperCase() === "A" || target.tagName.toUpperCase() === "BUTTON") return target;
    if (target.parentElement) return getTarget(target.parentElement);
    return target;
  };

  var internalClick = function internalClick(e) {
    var target = getTarget(e.target);
    if (target.tagName.toUpperCase() === "A" || target.tagName.toUpperCase() === "BUTTON") target.blur();
    if (onClick) onClick(e);
  };

  if (href || tertiary || appStore) {
    if (!href) return _react.default.createElement("a", _extends({
      id: id,
      onClick: internalClick,
      className: classes
    }, props, {
      disabled: !!disabled,
      title: title || ""
    }), children);
    return _react.default.createElement("a", _extends({
      id: id,
      onClick: internalClick,
      href: href,
      className: classes
    }, props, {
      disabled: !!disabled,
      title: title || ""
    }), children);
  }

  return _react.default.createElement("button", _extends({
    id: id,
    onClick: internalClick,
    className: classes,
    type: type
  }, props, {
    disabled: !!disabled,
    title: title || ""
  }), children);
};

exports.Button = Button;
Button.propTypes = {
  /** Button content */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /** Optional element id */
  id: _propTypes.default.string,

  /** Optional custom CSS classes */
  className: _propTypes.default.string,

  /** Button type if button actually resolves to be an html **button**
   *  Setting is ignored if you provide an href or use a tertiary or appStore button (which must be an anchor **a**)
   */
  type: _propTypes.default.oneOf(["submit", "reset", "button"]),

  /** Sets style to *secondary* or defaults to *primary* */
  secondary: _propTypes.default.bool,

  /** Sets style to *tertiary* or defaults to *primary* */
  tertiary: _propTypes.default.bool,

  /** Sets style to *appStore*, sets to the type provided or defaults to *primary* */
  appStore: _propTypes.default.string,

  /** Reduce the padding */
  small: _propTypes.default.bool,

  /** Set the button to *disabled* */
  disabled: _propTypes.default.bool,

  /** Secondary buttons only work with **orange**
   *  tertiary buttons only work with **white**
   */
  color: _propTypes.default.oneOf(["orange", "blue", "pink", "cyan", "yellow", "purple", "red", "white"]),

  /** Callback function for onClick */
  onClick: _propTypes.default.func,

  /** Href will return `a` instead of `button` */
  href: _propTypes.default.string
};